/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const deleteCustomerBodyExpectedCustomerVersionExclusiveMin = 0;
export const deleteCustomerBodyExpectedCustomerVersionMax = 9007199254740991;

export const DeleteCustomerBody = zod.object({
  expectedCustomerVersion: zod
    .int()
    .gt(deleteCustomerBodyExpectedCustomerVersionExclusiveMin)
    .max(deleteCustomerBodyExpectedCustomerVersionMax),
  confirmed: zod.literal(true),
});

export type DeleteCustomerBody = zod.input<typeof DeleteCustomerBody>;
export type DeleteCustomerBodyOutput = zod.output<typeof DeleteCustomerBody>;
